/**
* @Author: zachalam
* @Date:   2017-02-07T13:43:58-08:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-02-07T13:43:58-08:00
*/



import React, { Component } from 'react';
import HeaderNav from '../components/blocks/HeaderNav/Header';
import { connect } from 'react-redux';

class HeaderNavContainer extends Component {
  render() {
    return (
      <HeaderNav {...this.props} />
    );
  }
}

const mapStateToProps = (state) => {

  try {
    var avatar = state.profile.profile.data.avatar.data.urls.thumbs;
    var sex = state.profile.profile.data.sex;
  } catch(e) {
    var avatar = '';
    var sex = '';
  }

  return {
    username: state.profile.username,
    messages: state.profile.unread_messages,
    newFavorites: state.profile.new_favorites,
    profile: state.profile,
    avatar,
    alreadyUpgraded: Boolean(state.profile.is_premium) ||
        Boolean(sex === "Female")
  };
}

export default connect(mapStateToProps)(HeaderNavContainer);



// WEBPACK FOOTER //
// ./src/containers/HeaderNavContainer.jsx